module.exports = __webpack_public_path__ + "img/benefitinfo_pacific_image.36ae40c3.jpg";